export default __webpack_public_path__ + "static/media/gs-9.12435ca9.png";